export default class Directions {
	static get directions_service() {
		return this._directions_service ||
			(this._directions_service = new google.maps.DirectionsService());
	}

	constructor(element) {
		this.element = element;

		const data = JSON.parse(this.element.dataset.directions);

		// Geo Points
		this.origin_point =
			this.element.querySelector(data.origin_selector).geo_point;
		this.origin_point.directions = this;
		this.destination_point =
			this.element.querySelector(data.destination_selector).geo_point;
		this.destination_point.directions = this;

		// Distance
		if (data.distance_selectors) {
			this.distance_elements = {
				text: this.element.querySelector(data.distance_selectors.text),
				value: this.element.querySelector(data.distance_selectors.value),
				container: this.element.querySelector(data.distance_selectors.container)
			};
		}

		// Duration
		if (data.duration_selectors) {
			this.duration_elements = {
				text: this.element.querySelector(data.duration_selectors.text),
				value: this.element.querySelector(data.duration_selectors.value)
			};
		}

		// Map
		this.map = this.origin_point.map;

		if (this.map) {
			this._directions_renderer = new google.maps.DirectionsRenderer({
				map: this.map.google_map,
				suppressMarkers: true,
				suppressInfoWindows: true,
				preserveViewport: true
			});
		}

		// Update if Geo Points not updating
		if (
			!this.origin_point.updating_coordinates &&
			!this.destination_point.updating_coordinates
		) {
			this.update();
		}
	}

	clear() {
		// Map
		if (this._directions_renderer) {
			this._directions_renderer.setMap(null);
		}

		// Distance
		if (this.distance_elements) {
			this.distance_elements.value.value = null;
			this.distance_elements.text.innerText = '';
			this.distance_elements.container.classList.toggle('hidden', true);
		}

		// Duration
		if (this.duration_elements) {
			this.duration_elements.value.value = null;
			this.duration_elements.text.innerText = '';
		}
	}

	update({ clean_before = true } = {}, callback = null) {
		const self = this;

		function get_origin() {
			return self.origin_point.position;
		}

		function get_destination() {
			return self.destination_point.position;
		}

		// Check configuration flag and data for directions
		if (self.map && self.map._markers.length() < 2) return;

		// Clear directions before re-render
		if (clean_before) self.clear();

		const origin = get_origin(), destination = get_destination();

		// Not enough points for direction
		if (!(origin && destination)) {
			self.clear();
			// For GeoPointInput form submit callback
			if (callback) callback();
			return;
		}

		// Make API request
		self.constructor.directions_service.route(
			{ origin: origin, destination: destination, travelMode: 'DRIVING',
				unitSystem: google.maps.UnitSystem.IMPERIAL },
			(response, status) => {
				if (self.map && self.map.marker_dragging) return;

				if (
					!origin.equals(get_origin()) ||
					!destination.equals(get_destination())
				) return;

				let legs;

				if (status === google.maps.DirectionsStatus.OK) {
					if (self._directions_renderer) {
						self._directions_renderer.setMap(self.map.google_map);
						self._directions_renderer.setDirections(response);
					}

					legs = response.routes[0].legs[0];
					let passengerPlace = this.element.passenger_place;
					let customClearance = this.element.custom_clearance;

					// Distance
					if (this.distance_elements) {
						let distance = legs.distance.value;

						// Hide passenger place option if route longer than 500km
						if (passengerPlace) passengerPlace.toggleHidden(distance > 500000);
						// Toggle custom clearance option
						if (customClearance) {
							customClearance.toggleHidden(
								this.origin_point.country == this.destination_point.country
							);
						}
						this.distance_elements.value.value = distance;
						this.distance_elements.container.classList.toggle('hidden', !distance);
						this.distance_elements.text.innerText = legs.distance.text;
					} else {
						if (passengerPlace) passengerPlace.toggleHidden(false);
					}

					// Duration
					if (this.duration_elements) {
						this.duration_elements.value.value = legs.duration.value;
						this.duration_elements.text.innerText = legs.duration.text;
					}
				} else {
					self.clear();
				}

				// Calling custom callback
				if (callback) callback();

				// Trigger event
				self.element.dispatchEvent(
					new CustomEvent(
						'distance_updated',
						{ detail: legs ? legs.distance.value : null }
					)
				);
			}
		);
	}
}
